import { render } from "./Galeria.vue?vue&type=template&id=77bb271d"
const script = {}
script.render = render

export default script